import { useEffect } from 'react';
import type { VenueDetailCompactScreenProps } from './VenueDetailCompactScreen';
import { VenueDetailMobileShellNav } from './VenueDetailMobileShellNav';
import { VenueDetailReferenceScreen } from './VenueDetailReferenceScreen';
import './venue-detail-reference-posts.css';
import './venue-detail-reference-final.css';
import './venue-detail-owner-polish.css';

function currentVenueReference(): string | null {
  const match = window.location.pathname.match(/^\/venue\/([^/]+)\/?$/);
  if (!match) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

export function VenueDetailScreen(props: VenueDetailCompactScreenProps) {
  useEffect(() => {
    const slug = props.detail?.slug?.trim();
    if (!props.detail || !slug || currentVenueReference() === slug) return;

    const url = new URL(window.location.href);
    url.pathname = `/venue/${encodeURIComponent(slug)}`;
    window.history.replaceState(
      { ...(window.history.state ?? {}), hopperVenueId: props.detail.id },
      '',
      `${url.pathname}${url.search}${url.hash}`,
    );
  }, [props.detail]);

  useEffect(() => {
    document.body.classList.add('venue-detail-owner-open');
    return () => document.body.classList.remove('venue-detail-owner-open');
  }, []);

  const canonicalVenueId = props.detail?.id ?? props.venueId;

  return (
    <>
      <VenueDetailReferenceScreen {...props} venueId={canonicalVenueId} />
      <VenueDetailMobileShellNav onScan={props.onScan} />
    </>
  );
}
